import { WEB_STORAGE_PREFIX } from '@/utils/constants';

export const SUGER_ENTITLEMENT_ID_COOKIE_NAME = `${WEB_STORAGE_PREFIX}suger_entitlement_id`;
